import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { Region } from '@shapeable/kelp-forest-alliance-types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ExplorerTabs, GridBackButton, SiteHeaderLayout, SiteHeaderProvider } from '@shapeable/ui';
import { ComponentPropsProvider, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayoutProps, SliceLayoutBoundary } from '@shapeable/ui';
import { LinearRegionNavigationProvider } from '../providers/linear-region-navigation-provider';
const cls = classNames('region-explorer-layout');

// -------- Types -------->

// -------- Props -------->

export type RegionExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity: Region; 
};

export const RegionExplorerLayoutDefaultProps: Omit<RegionExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
  isAsideSticky: false,
  showAsideHeader: false,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(4)};
    margin-top: ${theme.UNIT(8)};

    .shp--entity-banner {
      h2.shp--entity-value__name {
        font-size: ${theme.FONT_SIZE(35)};
      }
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});

const TabsStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(6)};
  `,
});



// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Tabs: styled(ExplorerTabs)`${TabsStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
    
};

export const RegionExplorerLayout: Shapeable.FC<RegionExplorerLayoutProps> = (props) => {
  const { className, children, entity } = props;
  return (
    <ComponentPropsProvider value={{
      GridBackButton: {
        href: '/regions',
      },
      EntityBanner: {
        // maxHeight: 250,
        variant: 'overlay',
        showOverlay: true,
        customAspectRatio: { base: 3, desktop: 3},
        entityValueProps: { showImage: false, showOutlineNumber: false }
      },
    }}>
    <LinearRegionNavigationProvider>
    <My.Container>
      <SiteHeaderProvider value={{ variant: 'default' }}>
        <My.Header />
      </SiteHeaderProvider>
      <SliceLayoutBoundary boundary='none' >
      <My.Layout 
        split={[4.5, 5.5]}
        entity={entity}
        showSiteFooter={() => false}
        className={cls.name(className)}
        isAsideSticky={false}
        asideIsOffset={false}
        />
        </SliceLayoutBoundary>
    </My.Container>
    </LinearRegionNavigationProvider>
    </ComponentPropsProvider>
  )
};

RegionExplorerLayout.defaultProps = RegionExplorerLayoutDefaultProps;
RegionExplorerLayout.cls = cls;